import translations from './i18n';

const ext = {
  th: {
    // shared swal / notify
    ft_session_expired: 'Session ของท่านหมดอายุ กรุณา login เข้าสู่ระบบอีกครั้ง',
    ft_claim_success: 'ทำรายการรับเงินเรียบร้อย',
    ft_claim_no_balance: 'ไม่สามารถทำรายการได้ ไม่มียอดเงิน',
    ft_claim_failed: 'ไม่สามารถทำรายการได้',
    ft_not_login: 'คุณยังไม่ได้ทำการล๊อคอิน',
    ft_please_login: 'กรุณาลีอคอิน',
    ft_game_problem: 'ขณะนี้เกมมีปัญหากรุณารอซักครู่',
    ft_cancel_pro_confirm: 'คุณต้องการยกเลิกการใช้โปรใช่ หรือ ไม่?',
    ft_done: 'ดำเนินการเรียบร้อย',
    ft_cannot_proceed_wait: 'ไม่สามารถดำเนินการได้ โปรดรอซักครู่',
    ft_pro_not_eligible: 'ท่านไม่เข้าเงื่อนใขโปรโมชั่นนี้',
    ft_pro_pending: 'ท่านใช้โปรโมชั่นค้างไว้ สามารถเติมเงินได้เลย',

    // loss.js
    ft_cashback_title: 'คืนยอดเสีย',
    ft_cashback_total_all: 'คืนยอดเสียสะสมทั้งหมด',
    ft_cashback_total_month: 'คืนยอดเสียสะสมเดือนนี้',
    ft_cashback_percent: 'คืนยอดเสีย',
    ft_start_amount: 'ยอดเริ่มต้น 0 บาท',
    ft_your_loss: 'ยอดเสียของคุณ',
    ft_withdraw: 'ถอนเงิน',
    ft_transaction_history: 'ประวัติการทำรายการ',
    ft_no_transaction: 'ไม่พบรายการ...',

    // checkin.js
    ft_category: 'หมวดหมู่',
    ft_two_types: '2 ประเภท',
    ft_popular_games: 'เกมส์ยอดนิยม',
    ft_game_camps: 'ค่ายเกมส์',
    ft_camps: 'ค่าย',
    ft_live_casino: 'คาสิโนสด',
    ft_sport: 'สปอร์ต',
    ft_fishing: 'ยิงปลา',
    ft_arcade: 'อาร์เคด',
    ft_games_unit: 'เกมส์',
    ft_day_label: 'วันที',

    // checkinx.js
    ft_daily_checkin: 'เช็คอินประจำวัน',
    ft_turnover_condition: 'เทิร์นโอเวอร์ 500.- ขึ้นไป',
    ft_checkin_sub: 'รับทุกวันเพียงเข้ามาเช็คอิน พร้อมทั้งสะสมเพื่อรับรางวัลที่สูงขึ้น',
    ft_today: 'วันนี้',
    ft_checkin_collect: 'เช็คอินสะสม',
    ft_checkin_collect_sub: 'อีก 3 วัน ได้รับสูงสุด ฿5',
    ft_day_unit: 'วัน',
    ft_max: 'สูงสุด',
    ft_three_days: '3 วัน',
    ft_seven_days: '7 วัน',
    ft_fifteen_days: '15 วัน',
    ft_twentyfive_days: '25 วัน',

    // luckyfortune.js
    ft_wheel_title: 'กงล้อพารวย',
    ft_spin_wheel: 'หมุนกงล้อ',
    ft_deposit_get_ticket_1: 'ฝากเงินสะสม',
    ft_deposit_get_ticket_2: 'บาท ได้ 1 ตั๋ว',
    ft_terms_of_service: 'เงื่อนไขการให้บริการ',
    ft_wheel_term_1: '• ฝากเงินสะสมครบ 1,000 บาท จะได้รับ 1 ตั๋ว (สูงสุด 5 ตั๋ว / วัน)',
    ft_wheel_term_2_a: '• ยอดฝากสะสมจะ ',
    ft_wheel_term_2_reset: 'รีเซ็ตเป็น 0',
    ft_wheel_term_2_b: ' ในเวลา 00.00 น. ของทุกวัน',
    ft_wheel_term_3: '*ตั๋วกงล้อจะถูกคำนวณและได้รับ ต่อเมื่อเข้ามาที่หน้านี้เท่านั้น หากไม่เข้าจะไม่ได้รับ',
    ft_congratulations: 'ขอแสดงความยินดี',
    ft_receive_reward_at: 'รับของรางวัลได้ที่',
    ft_receive_reward: 'รับรางวัล',
    ft_close: 'ปิด',

    // cardminigame.js
    ft_card_done_today: 'คุณเปิดไพ่ครบแล้วในวันนี้ กรุณารอวันใหม่',
    ft_not_enough_points: 'แต้มไม่พอในเล่นเกมนี้',
    ft_login_before_play: 'กรุณาเข้าสู่ระบบก่อนเล่น',
    ft_select_event_before_play: 'กรุณาเลือกกิจกรรมก่อนเล่น',
    ft_reset_cards_title: 'ทางเราจะ reset ไพ่ให้ใหม่',
    ft_reset_cards_text: 'กรุณากดปุ่ม "ตกลง" เพื่อทำการสุ่มใหม่',
    ft_cancel: 'ยกเลิก',
    ft_card_event: 'กิจกรรมเปิดไพ่',
    ft_points_available: 'จำนวนแต้มที่ใช้ได้',
    ft_points_unit: 'แต้ม',
    ft_enter_play: 'เข้าเล่น',
    ft_event: 'กิจกรรม',
    ft_open_card: 'เปิดไพ่',
    ft_card_shuffled: 'สุ่มไพ่เรียบร้อย',
    ft_join_conditions: 'เงื่อนไขในการร่วมสนุก',
    ft_open_condition_none: 'เงื่อนไขในการเปิด: ไม่พบ',
    ft_open_twice_a_day: 'สามารถเปิดได้วันละ 2 ครั้ง เท่านั้น',
    ft_details: 'รายละเอียด :',
    ft_card_reward_list: 'ฝาก 100 - 999 บาท\nรับสิทธิ์เปิดฟรี วันละ 2 ครั้ง\n\nแวมไพร์ - ลุ้นรับ เครดิตฟรี 50\nเจสัน วอร์ฮีส์ - ลุ้นรับ เครดิตฟรี 10\nเฟรดดี้ ครูเกอร์ - ลุ้นรับ เครดิตฟรี 15\nผีดิบ - ลุ้นรับ เครดิตฟรี 25\nนักบวช - ลุ้นรับ เครดิตฟรี 5',
    ft_card_history_title: 'ประวัติการเล่นเปิดไพ่',
    ft_all: 'ทั้งหมด',
    ft_history_transaction: 'ประวัติทำรายการ',
    ft_time: 'เวลา',
    ft_amount: 'จำนวนเงิน',
    ft_status: 'สถานะ :',
    ft_status_processing: 'กำลังดำเนินการ',
    ft_status_pending: 'รอดำเนินการ',
    ft_status_cancelled_by_player: 'ยกเลิก (ยกเลิกโดยผู้เล่น)',
    ft_status_failed_by_system: 'ไม่สำเร็จ (โดยระบบ)',
    ft_status_success: 'สำเร็จ',

    // affiliate.js
    ft_affiliate_title: 'เเนะนำเพื่อน',
    ft_overview: 'ภาพรวม',
    ft_members: 'สมาชิก',
    ft_income_summary: 'สรุปรายได้',
    ft_network: 'เครือข่าย',
    ft_income_from_network_all: 'รายได้จากเครือข่าย ทั้งหมด',
    ft_from_last_month: 'จากเดือนที่แล้ว',
    ft_invite_link: 'ลิงก์เชิญชวน',
    ft_copy: 'คัดลอก',
    ft_copied: 'คัดลอกแล้ว!',
    ft_withdrawable_income: 'รายได้ที่ถอนได้',
    ft_withdraw_income: 'ถอนรายได้',
    ft_total_link_clicks: 'จำนวนคลิกลิงค์ทั้งหมด',
    ft_total_members: 'จำนวนสมาชิกทั้งหมด',
    ft_new_members_today: 'สมาชิกใหม่วันนี้',
    ft_people_unit: 'คน',
    ft_history: 'ประวัติ',
    ft_how_to_build_network: 'วิธีการสร้างเครือข่าย',
    ft_total_active: 'ยอดแอคทีฟทั้งหมด',
    ft_seven_days_ago: '7 วันที่เเล้ว',
    ft_last_month: 'เดือนที่เเล้ว',
    ft_total_referred_members: 'แนะนำสมาชิกทั้งหมด',
    ft_all_play_types: 'ยอดการเล่นทุกประเภท',
    ft_rank_no: 'ลำดับที่',
    ft_network_details: 'รายละเอียกเครือข่าย',
    ft_date: 'วันที่',
    ft_withdraw_amount: 'ยอดถอน',
    ft_search_income_source: 'ค้นหาที่มารายได้',
    ft_all_levels: 'ทุกเลเวล',
    ft_all_types: 'ทุกประเภท',
    ft_type_slot: 'สล็อต-slot',
    ft_type_casino: 'คาสิโน-casino',
    ft_type_winloss: 'ยอดเสีย-winloss',
    ft_today_to_today: 'วันนี้ — วันนี้',
    ft_clear: 'ล้างค่า',
    ft_search: 'ค้นหา',
    ft_viewing_period: 'คุณกำลังดูช่วงเวลา',
    ft_level_no: 'ระดับที่',
    ft_income_detail: 'รายละเอียดการทำรายได้',
    ft_type: 'ประเภท',
    ft_bet_amount: 'ยอดแทง',
    ft_income: 'รายได้',
    ft_easy_rich_with_us: 'รวยง่ายๆ กับ เรา',
    ft_share_link_earn: 'แค่แชร์ลิงก์ก็สร้างรายได้',
  },
  en: {
    ft_session_expired: 'Your session has expired. Please log in again.',
    ft_claim_success: 'Transaction completed successfully',
    ft_claim_no_balance: 'Cannot proceed, no balance available',
    ft_claim_failed: 'Cannot complete the transaction',
    ft_not_login: 'You are not logged in yet',
    ft_please_login: 'Please log in',
    ft_game_problem: 'The game is currently having an issue, please wait a moment',
    ft_cancel_pro_confirm: 'Do you want to cancel this promotion?',
    ft_done: 'Done successfully',
    ft_cannot_proceed_wait: 'Cannot proceed, please wait a moment',
    ft_pro_not_eligible: 'You do not meet the conditions of this promotion',
    ft_pro_pending: 'You have a pending promotion, you can top up now',

    ft_cashback_title: 'Cashback',
    ft_cashback_total_all: 'Total accumulated cashback',
    ft_cashback_total_month: 'Accumulated cashback this month',
    ft_cashback_percent: 'Cashback',
    ft_start_amount: 'Starting amount 0 THB',
    ft_your_loss: 'Your loss',
    ft_withdraw: 'Withdraw',
    ft_transaction_history: 'Transaction history',
    ft_no_transaction: 'No transactions found...',

    ft_category: 'Category',
    ft_two_types: '2 types',
    ft_popular_games: 'Popular games',
    ft_game_camps: 'Game providers',
    ft_camps: 'providers',
    ft_live_casino: 'Live Casino',
    ft_sport: 'Sport',
    ft_fishing: 'Fishing',
    ft_arcade: 'Arcade',
    ft_games_unit: 'games',
    ft_day_label: 'Day',

    ft_daily_checkin: 'Daily Check-in',
    ft_turnover_condition: 'Turnover 500.- or more',
    ft_checkin_sub: 'Get rewards every day just by checking in, and collect to earn higher rewards',
    ft_today: 'Today',
    ft_checkin_collect: 'Collect Check-in',
    ft_checkin_collect_sub: '3 more days to get up to ฿5',
    ft_day_unit: 'days',
    ft_max: 'Max',
    ft_three_days: '3 days',
    ft_seven_days: '7 days',
    ft_fifteen_days: '15 days',
    ft_twentyfive_days: '25 days',

    ft_wheel_title: 'Lucky Wheel',
    ft_spin_wheel: 'Spin the wheel',
    ft_deposit_get_ticket_1: 'Accumulate deposits of',
    ft_deposit_get_ticket_2: 'THB to get 1 ticket',
    ft_terms_of_service: 'Terms of service',
    ft_wheel_term_1: '• Accumulate deposits of 1,000 THB to receive 1 ticket (max 5 tickets / day)',
    ft_wheel_term_2_a: '• Accumulated deposit will ',
    ft_wheel_term_2_reset: 'reset to 0',
    ft_wheel_term_2_b: ' at 00:00 every day',
    ft_wheel_term_3: '*Wheel tickets are calculated and granted only when you enter this page. If you do not enter, you will not receive them',
    ft_congratulations: 'Congratulations',
    ft_receive_reward_at: 'Receive your reward at',
    ft_receive_reward: 'Claim reward',
    ft_close: 'Close',

    ft_card_done_today: 'You have flipped all cards today, please wait for a new day',
    ft_not_enough_points: 'Not enough points to play this game',
    ft_login_before_play: 'Please log in before playing',
    ft_select_event_before_play: 'Please select an event before playing',
    ft_reset_cards_title: 'We will reset the cards for you',
    ft_reset_cards_text: 'Please press "OK" to reshuffle',
    ft_cancel: 'Cancel',
    ft_card_event: 'Card Flip Event',
    ft_points_available: 'Available points',
    ft_points_unit: 'points',
    ft_enter_play: 'Play',
    ft_event: 'Event',
    ft_open_card: 'Flip card',
    ft_card_shuffled: 'Cards shuffled successfully',
    ft_join_conditions: 'Conditions to join',
    ft_open_condition_none: 'Opening condition: none',
    ft_open_twice_a_day: 'Can be opened only 2 times per day',
    ft_details: 'Details:',
    ft_card_reward_list: 'Deposit 100 - 999 THB\nGet free flips, 2 times per day\n\nVampire - chance to win 50 free credit\nJason Voorhees - chance to win 10 free credit\nFreddy Krueger - chance to win 15 free credit\nZombie - chance to win 25 free credit\nPriest - chance to win 5 free credit',
    ft_card_history_title: 'Card flip history',
    ft_all: 'All',
    ft_history_transaction: 'Transaction history',
    ft_time: 'Time',
    ft_amount: 'Amount',
    ft_status: 'Status:',
    ft_status_processing: 'Processing',
    ft_status_pending: 'Pending',
    ft_status_cancelled_by_player: 'Cancelled (by player)',
    ft_status_failed_by_system: 'Failed (by system)',
    ft_status_success: 'Success',

    ft_affiliate_title: 'Refer a friend',
    ft_overview: 'Overview',
    ft_members: 'Members',
    ft_income_summary: 'Income summary',
    ft_network: 'Network',
    ft_income_from_network_all: 'Total income from network',
    ft_from_last_month: 'from last month',
    ft_invite_link: 'Invite link',
    ft_copy: 'Copy',
    ft_copied: 'Copied!',
    ft_withdrawable_income: 'Withdrawable income',
    ft_withdraw_income: 'Withdraw income',
    ft_total_link_clicks: 'Total link clicks',
    ft_total_members: 'Total members',
    ft_new_members_today: 'New members today',
    ft_people_unit: 'people',
    ft_history: 'History',
    ft_how_to_build_network: 'How to build a network',
    ft_total_active: 'Total active',
    ft_seven_days_ago: '7 days ago',
    ft_last_month: 'Last month',
    ft_total_referred_members: 'Total referred members',
    ft_all_play_types: 'All play types',
    ft_rank_no: 'Rank',
    ft_network_details: 'Network details',
    ft_date: 'Date',
    ft_withdraw_amount: 'Withdraw amount',
    ft_search_income_source: 'Search income source',
    ft_all_levels: 'All levels',
    ft_all_types: 'All types',
    ft_type_slot: 'Slot',
    ft_type_casino: 'Casino',
    ft_type_winloss: 'Win/Loss',
    ft_today_to_today: 'Today — Today',
    ft_clear: 'Clear',
    ft_search: 'Search',
    ft_viewing_period: 'You are viewing the period',
    ft_level_no: 'Level',
    ft_income_detail: 'Income details',
    ft_type: 'Type',
    ft_bet_amount: 'Bet amount',
    ft_income: 'Income',
    ft_easy_rich_with_us: 'Get rich easily with us',
    ft_share_link_earn: 'Just share the link and earn',
  },
  zh: {
    ft_session_expired: '您的登录已过期，请重新登录。',
    ft_claim_success: '交易成功完成',
    ft_claim_no_balance: '无法操作，没有余额',
    ft_claim_failed: '无法完成交易',
    ft_not_login: '您尚未登录',
    ft_please_login: '请登录',
    ft_game_problem: '游戏目前有问题，请稍候',
    ft_cancel_pro_confirm: '您要取消使用此优惠吗？',
    ft_done: '操作成功',
    ft_cannot_proceed_wait: '无法操作，请稍候',
    ft_pro_not_eligible: '您不符合此优惠的条件',
    ft_pro_pending: '您有一个待处理的优惠，可以立即充值',

    ft_cashback_title: '亏损返还',
    ft_cashback_total_all: '累计亏损返还总额',
    ft_cashback_total_month: '本月累计亏损返还',
    ft_cashback_percent: '亏损返还',
    ft_start_amount: '起始金额 0 泰铢',
    ft_your_loss: '您的亏损',
    ft_withdraw: '提款',
    ft_transaction_history: '交易记录',
    ft_no_transaction: '未找到记录...',

    ft_category: '分类',
    ft_two_types: '2 种类型',
    ft_popular_games: '热门游戏',
    ft_game_camps: '游戏厂商',
    ft_camps: '厂商',
    ft_live_casino: '真人娱乐场',
    ft_sport: '体育',
    ft_fishing: '捕鱼',
    ft_arcade: '街机',
    ft_games_unit: '游戏',
    ft_day_label: '第',

    ft_daily_checkin: '每日签到',
    ft_turnover_condition: '流水 500.- 以上',
    ft_checkin_sub: '每天只需签到即可领取奖励，连续累积可获得更高奖励',
    ft_today: '今天',
    ft_checkin_collect: '累积签到',
    ft_checkin_collect_sub: '再签 3 天最高可得 ฿5',
    ft_day_unit: '天',
    ft_max: '最高',
    ft_three_days: '3 天',
    ft_seven_days: '7 天',
    ft_fifteen_days: '15 天',
    ft_twentyfive_days: '25 天',

    ft_wheel_title: '幸运转盘',
    ft_spin_wheel: '转动转盘',
    ft_deposit_get_ticket_1: '累计存款',
    ft_deposit_get_ticket_2: '泰铢可得 1 张票',
    ft_terms_of_service: '服务条款',
    ft_wheel_term_1: '• 累计存款满 1,000 泰铢可获得 1 张票（每天最多 5 张票）',
    ft_wheel_term_2_a: '• 累计存款将于 ',
    ft_wheel_term_2_reset: '重置为 0',
    ft_wheel_term_2_b: ' 每天 00:00',
    ft_wheel_term_3: '*转盘票仅在您进入此页面时才计算和发放，如不进入将无法获得',
    ft_congratulations: '恭喜',
    ft_receive_reward_at: '在此领取奖励',
    ft_receive_reward: '领取奖励',
    ft_close: '关闭',

    ft_card_done_today: '您今天已翻完所有牌，请等待新的一天',
    ft_not_enough_points: '积分不足，无法玩此游戏',
    ft_login_before_play: '请先登录再游戏',
    ft_select_event_before_play: '请先选择活动再游戏',
    ft_reset_cards_title: '我们将为您重置卡牌',
    ft_reset_cards_text: '请按"确定"重新洗牌',
    ft_cancel: '取消',
    ft_card_event: '翻牌活动',
    ft_points_available: '可用积分',
    ft_points_unit: '积分',
    ft_enter_play: '进入游戏',
    ft_event: '活动',
    ft_open_card: '翻牌',
    ft_card_shuffled: '洗牌成功',
    ft_join_conditions: '参与条件',
    ft_open_condition_none: '开启条件：无',
    ft_open_twice_a_day: '每天仅可开启 2 次',
    ft_details: '详情：',
    ft_card_reward_list: '存款 100 - 999 泰铢\n获得免费翻牌，每天 2 次\n\n吸血鬼 - 有机会赢取 50 免费额度\n杰森·沃赫斯 - 有机会赢取 10 免费额度\n弗莱迪·克鲁格 - 有机会赢取 15 免费额度\n僵尸 - 有机会赢取 25 免费额度\n牧师 - 有机会赢取 5 免费额度',
    ft_card_history_title: '翻牌游戏记录',
    ft_all: '全部',
    ft_history_transaction: '交易记录',
    ft_time: '时间',
    ft_amount: '金额',
    ft_status: '状态：',
    ft_status_processing: '处理中',
    ft_status_pending: '等待处理',
    ft_status_cancelled_by_player: '已取消（玩家取消）',
    ft_status_failed_by_system: '失败（系统）',
    ft_status_success: '成功',

    ft_affiliate_title: '推荐好友',
    ft_overview: '概览',
    ft_members: '会员',
    ft_income_summary: '收入汇总',
    ft_network: '网络',
    ft_income_from_network_all: '网络总收入',
    ft_from_last_month: '较上月',
    ft_invite_link: '邀请链接',
    ft_copy: '复制',
    ft_copied: '已复制！',
    ft_withdrawable_income: '可提取收入',
    ft_withdraw_income: '提取收入',
    ft_total_link_clicks: '链接点击总数',
    ft_total_members: '会员总数',
    ft_new_members_today: '今日新增会员',
    ft_people_unit: '人',
    ft_history: '历史记录',
    ft_how_to_build_network: '如何建立网络',
    ft_total_active: '活跃总数',
    ft_seven_days_ago: '7 天前',
    ft_last_month: '上月',
    ft_total_referred_members: '推荐会员总数',
    ft_all_play_types: '所有游戏类型',
    ft_rank_no: '排名',
    ft_network_details: '网络详情',
    ft_date: '日期',
    ft_withdraw_amount: '提款金额',
    ft_search_income_source: '搜索收入来源',
    ft_all_levels: '所有等级',
    ft_all_types: '所有类型',
    ft_type_slot: '老虎机-slot',
    ft_type_casino: '娱乐场-casino',
    ft_type_winloss: '亏损-winloss',
    ft_today_to_today: '今天 — 今天',
    ft_clear: '清除',
    ft_search: '搜索',
    ft_viewing_period: '您正在查看的时间段',
    ft_level_no: '级别',
    ft_income_detail: '收入明细',
    ft_type: '类型',
    ft_bet_amount: '投注额',
    ft_income: '收入',
    ft_easy_rich_with_us: '与我们一起轻松致富',
    ft_share_link_earn: '只需分享链接即可赚钱',
  },
  ja: {
    ft_session_expired: 'セッションの有効期限が切れました。再度ログインしてください。',
    ft_claim_success: '取引が正常に完了しました',
    ft_claim_no_balance: '残高がないため処理できません',
    ft_claim_failed: '取引を完了できません',
    ft_not_login: 'まだログインしていません',
    ft_please_login: 'ログインしてください',
    ft_game_problem: '現在ゲームに問題が発生しています。少々お待ちください',
    ft_cancel_pro_confirm: 'このプロモーションをキャンセルしますか？',
    ft_done: '処理が完了しました',
    ft_cannot_proceed_wait: '処理できません。少々お待ちください',
    ft_pro_not_eligible: 'このプロモーションの条件を満たしていません',
    ft_pro_pending: '保留中のプロモーションがあります。今すぐ入金できます',

    ft_cashback_title: 'キャッシュバック',
    ft_cashback_total_all: '累計キャッシュバック合計',
    ft_cashback_total_month: '今月の累計キャッシュバック',
    ft_cashback_percent: 'キャッシュバック',
    ft_start_amount: '開始額 0 バーツ',
    ft_your_loss: 'あなたの損失',
    ft_withdraw: '出金',
    ft_transaction_history: '取引履歴',
    ft_no_transaction: '取引が見つかりません...',

    ft_category: 'カテゴリー',
    ft_two_types: '2 種類',
    ft_popular_games: '人気ゲーム',
    ft_game_camps: 'ゲームプロバイダー',
    ft_camps: 'プロバイダー',
    ft_live_casino: 'ライブカジノ',
    ft_sport: 'スポーツ',
    ft_fishing: 'フィッシング',
    ft_arcade: 'アーケード',
    ft_games_unit: 'ゲーム',
    ft_day_label: '日目',

    ft_daily_checkin: 'デイリーチェックイン',
    ft_turnover_condition: 'ターンオーバー 500.- 以上',
    ft_checkin_sub: 'チェックインするだけで毎日報酬を獲得、積み重ねてより高い報酬を獲得',
    ft_today: '今日',
    ft_checkin_collect: '累計チェックイン',
    ft_checkin_collect_sub: 'あと3日で最大 ฿5 獲得',
    ft_day_unit: '日',
    ft_max: '最大',
    ft_three_days: '3 日',
    ft_seven_days: '7 日',
    ft_fifteen_days: '15 日',
    ft_twentyfive_days: '25 日',

    ft_wheel_title: 'ラッキーホイール',
    ft_spin_wheel: 'ホイールを回す',
    ft_deposit_get_ticket_1: '累計入金額',
    ft_deposit_get_ticket_2: 'バーツでチケット1枚',
    ft_terms_of_service: '利用規約',
    ft_wheel_term_1: '• 累計入金 1,000 バーツでチケット1枚獲得（1日最大5枚）',
    ft_wheel_term_2_a: '• 累計入金額は ',
    ft_wheel_term_2_reset: '0 にリセット',
    ft_wheel_term_2_b: ' 毎日 00:00 に',
    ft_wheel_term_3: '*ホイールチケットはこのページに入った場合のみ計算・付与されます。入らない場合は付与されません',
    ft_congratulations: 'おめでとうございます',
    ft_receive_reward_at: '報酬の受け取り場所',
    ft_receive_reward: '報酬を受け取る',
    ft_close: '閉じる',

    ft_card_done_today: '本日のカードをすべてめくりました。新しい日をお待ちください',
    ft_not_enough_points: 'このゲームをプレイするにはポイントが不足しています',
    ft_login_before_play: 'プレイする前にログインしてください',
    ft_select_event_before_play: 'プレイする前にイベントを選択してください',
    ft_reset_cards_title: 'カードをリセットします',
    ft_reset_cards_text: '「OK」を押して再シャッフルしてください',
    ft_cancel: 'キャンセル',
    ft_card_event: 'カードめくりイベント',
    ft_points_available: '利用可能ポイント',
    ft_points_unit: 'ポイント',
    ft_enter_play: 'プレイ',
    ft_event: 'イベント',
    ft_open_card: 'カードをめくる',
    ft_card_shuffled: 'シャッフル完了',
    ft_join_conditions: '参加条件',
    ft_open_condition_none: '開封条件：なし',
    ft_open_twice_a_day: '1日2回のみ開封可能',
    ft_details: '詳細：',
    ft_card_reward_list: '入金 100 - 999 バーツ\n無料めくり、1日2回\n\nヴァンパイア - フリークレジット 50 のチャンス\nジェイソン・ボーヒーズ - フリークレジット 10 のチャンス\nフレディ・クルーガー - フリークレジット 15 のチャンス\nゾンビ - フリークレジット 25 のチャンス\n司祭 - フリークレジット 5 のチャンス',
    ft_card_history_title: 'カードめくり履歴',
    ft_all: 'すべて',
    ft_history_transaction: '取引履歴',
    ft_time: '時間',
    ft_amount: '金額',
    ft_status: 'ステータス：',
    ft_status_processing: '処理中',
    ft_status_pending: '待機中',
    ft_status_cancelled_by_player: 'キャンセル（プレイヤーによる）',
    ft_status_failed_by_system: '失敗（システムによる）',
    ft_status_success: '成功',

    ft_affiliate_title: '友達を紹介',
    ft_overview: '概要',
    ft_members: 'メンバー',
    ft_income_summary: '収入概要',
    ft_network: 'ネットワーク',
    ft_income_from_network_all: 'ネットワークからの総収入',
    ft_from_last_month: '先月比',
    ft_invite_link: '招待リンク',
    ft_copy: 'コピー',
    ft_copied: 'コピーしました！',
    ft_withdrawable_income: '出金可能な収入',
    ft_withdraw_income: '収入を出金',
    ft_total_link_clicks: 'リンククリック総数',
    ft_total_members: 'メンバー総数',
    ft_new_members_today: '本日の新規メンバー',
    ft_people_unit: '人',
    ft_history: '履歴',
    ft_how_to_build_network: 'ネットワークの作り方',
    ft_total_active: 'アクティブ総数',
    ft_seven_days_ago: '7日前',
    ft_last_month: '先月',
    ft_total_referred_members: '紹介メンバー総数',
    ft_all_play_types: 'すべてのプレイタイプ',
    ft_rank_no: '順位',
    ft_network_details: 'ネットワーク詳細',
    ft_date: '日付',
    ft_withdraw_amount: '出金額',
    ft_search_income_source: '収入源を検索',
    ft_all_levels: 'すべてのレベル',
    ft_all_types: 'すべてのタイプ',
    ft_type_slot: 'スロット-slot',
    ft_type_casino: 'カジノ-casino',
    ft_type_winloss: '損失-winloss',
    ft_today_to_today: '今日 — 今日',
    ft_clear: 'クリア',
    ft_search: '検索',
    ft_viewing_period: '表示中の期間',
    ft_level_no: 'レベル',
    ft_income_detail: '収入明細',
    ft_type: 'タイプ',
    ft_bet_amount: 'ベット額',
    ft_income: '収入',
    ft_easy_rich_with_us: '私たちと一緒に簡単にお金持ちに',
    ft_share_link_earn: 'リンクを共有するだけで収入を得る',
  },
  my: {
    ft_session_expired: 'သင်၏ session သက်တမ်းကုန်သွားပါပြီ။ ကျေးဇူးပြု၍ ပြန်လည်ဝင်ရောက်ပါ။',
    ft_claim_success: 'ငွေလွှဲမှု အောင်မြင်စွာ ပြီးဆုံးပါပြီ',
    ft_claim_no_balance: 'လက်ကျန်ငွေ မရှိသဖြင့် မဆောင်ရွက်နိုင်ပါ',
    ft_claim_failed: 'ငွေလွှဲမှု မပြီးဆုံးနိုင်ပါ',
    ft_not_login: 'သင် အကောင့်ဝင်ရောက်ထားခြင်း မရှိသေးပါ',
    ft_please_login: 'ကျေးဇူးပြု၍ အကောင့်ဝင်ပါ',
    ft_game_problem: 'ဂိမ်းတွင် ယာယီ ပြဿနာရှိနေသည်၊ ခဏစောင့်ပါ',
    ft_cancel_pro_confirm: 'ဤပရိုမိုးရှင်းကို ပယ်ဖျက်လိုပါသလား?',
    ft_done: 'အောင်မြင်စွာ ဆောင်ရွက်ပြီးပါပြီ',
    ft_cannot_proceed_wait: 'မဆောင်ရွက်နိုင်ပါ၊ ခဏစောင့်ပါ',
    ft_pro_not_eligible: 'သင်သည် ဤပရိုမိုးရှင်း၏ စည်းကမ်းချက်များနှင့် မကိုက်ညီပါ',
    ft_pro_pending: 'သင့်တွင် ဆိုင်းငံ့ထားသော ပရိုမိုးရှင်းရှိသည်၊ ယခု ငွေဖြည့်နိုင်ပါသည်',

    ft_cashback_title: 'အရှုံးပြန်အမ်း',
    ft_cashback_total_all: 'စုစုပေါင်း အရှုံးပြန်အမ်း စုစည်းမှု',
    ft_cashback_total_month: 'ဤလ အရှုံးပြန်အမ်း စုစည်းမှု',
    ft_cashback_percent: 'အရှုံးပြန်အမ်း',
    ft_start_amount: 'စတင်ပမာဏ 0 ဘတ်',
    ft_your_loss: 'သင်၏ အရှုံး',
    ft_withdraw: 'ငွေထုတ်ရန်',
    ft_transaction_history: 'ငွေလွှဲမှတ်တမ်း',
    ft_no_transaction: 'မှတ်တမ်း မတွေ့ပါ...',

    ft_category: 'အမျိုးအစား',
    ft_two_types: 'အမျိုးအစား 2 မျိုး',
    ft_popular_games: 'ရေပန်းစားသော ဂိမ်းများ',
    ft_game_camps: 'ဂိမ်းကုမ္ပဏီများ',
    ft_camps: 'ကုမ္ပဏီ',
    ft_live_casino: 'တိုက်ရိုက် ကာစီနို',
    ft_sport: 'အားကစား',
    ft_fishing: 'ငါးဖမ်း',
    ft_arcade: 'အာကေ့ဒ်',
    ft_games_unit: 'ဂိမ်း',
    ft_day_label: 'နေ့',

    ft_daily_checkin: 'နေ့စဉ် ချက်အင်',
    ft_turnover_condition: 'တာ့န်အိုဗာ 500.- အထက်',
    ft_checkin_sub: 'ချက်အင်ဝင်ရုံဖြင့် နေ့စဉ် ဆုလက်ဆောင်ရယူပါ၊ စုဆောင်းခြင်းဖြင့် ပိုမိုမြင့်မားသော ဆုများ ရယူနိုင်ပါသည်',
    ft_today: 'ယနေ့',
    ft_checkin_collect: 'ချက်အင် စုဆောင်းမှု',
    ft_checkin_collect_sub: 'နောက်ထပ် 3 ရက်ဆို အများဆုံး ฿5 ရမည်',
    ft_day_unit: 'ရက်',
    ft_max: 'အများဆုံး',
    ft_three_days: '3 ရက်',
    ft_seven_days: '7 ရက်',
    ft_fifteen_days: '15 ရက်',
    ft_twentyfive_days: '25 ရက်',

    ft_wheel_title: 'ကံကောင်းဘီး',
    ft_spin_wheel: 'ဘီးလှည့်ရန်',
    ft_deposit_get_ticket_1: 'ငွေဖြည့်စုဆောင်းမှု',
    ft_deposit_get_ticket_2: 'ဘတ်ဖြင့် လက်မှတ် 1 ခုရမည်',
    ft_terms_of_service: 'ဝန်ဆောင်မှု စည်းကမ်းချက်များ',
    ft_wheel_term_1: '• ငွေဖြည့် 1,000 ဘတ် စုဆောင်းပါက လက်မှတ် 1 ခုရမည် (တစ်နေ့ အများဆုံး 5 ခု)',
    ft_wheel_term_2_a: '• စုဆောင်းငွေဖြည့်ပမာဏသည် ',
    ft_wheel_term_2_reset: '0 သို့ ပြန်သတ်မှတ်မည်',
    ft_wheel_term_2_b: ' နေ့စဉ် 00:00 နာရီတွင်',
    ft_wheel_term_3: '*ဘီးလက်မှတ်များကို ဤစာမျက်နှာသို့ ဝင်ရောက်မှသာ တွက်ချက်ပေးအပ်ပါသည်၊ မဝင်ပါက မရရှိပါ',
    ft_congratulations: 'ဂုဏ်ယူပါသည်',
    ft_receive_reward_at: 'ဆုလက်ဆောင် ရယူနိုင်သည့်နေရာ',
    ft_receive_reward: 'ဆုလက်ဆောင်ရယူရန်',
    ft_close: 'ပိတ်ရန်',

    ft_card_done_today: 'ယနေ့ ဖဲချပ်အားလုံး ဖွင့်ပြီးပါပြီ၊ နေ့သစ်ကို စောင့်ပါ',
    ft_not_enough_points: 'ဤဂိမ်းကစားရန် ပွိုင့်မလုံလောက်ပါ',
    ft_login_before_play: 'မကစားမီ အကောင့်ဝင်ပါ',
    ft_select_event_before_play: 'မကစားမီ အစီအစဉ်ကို ရွေးချယ်ပါ',
    ft_reset_cards_title: 'ကျွန်ုပ်တို့ ဖဲချပ်များကို ပြန်လည်သတ်မှတ်ပေးပါမည်',
    ft_reset_cards_text: 'ပြန်လည်ရောမြွှေရန် "OK" ကို နှိပ်ပါ',
    ft_cancel: 'ပယ်ဖျက်ရန်',
    ft_card_event: 'ဖဲဖွင့်ပွဲ',
    ft_points_available: 'အသုံးပြုနိုင်သော ပွိုင့်',
    ft_points_unit: 'ပွိုင့်',
    ft_enter_play: 'ကစားရန်',
    ft_event: 'အစီအစဉ်',
    ft_open_card: 'ဖဲဖွင့်ရန်',
    ft_card_shuffled: 'ဖဲရောမြွှေခြင်း အောင်မြင်ပါပြီ',
    ft_join_conditions: 'ပါဝင်ရန် စည်းကမ်းချက်များ',
    ft_open_condition_none: 'ဖွင့်ရန် စည်းကမ်းချက်: မရှိ',
    ft_open_twice_a_day: 'တစ်နေ့ 2 ကြိမ်သာ ဖွင့်နိုင်သည်',
    ft_details: 'အသေးစိတ်:',
    ft_card_reward_list: 'ငွေဖြည့် 100 - 999 ဘတ်\nအခမဲ့ ဖွင့်ခွင့် တစ်နေ့ 2 ကြိမ်\n\nဗမ်ပိုင် - အခမဲ့ ခရက်ဒစ် 50 ရရှိရန် အခွင့်အရေး\nဂျေဆင် ဗိုဟိစ် - အခမဲ့ ခရက်ဒစ် 10 ရရှိရန် အခွင့်အရေး\nဖရက်ဒီ ခရူဂါ - အခမဲ့ ခရက်ဒစ် 15 ရရှိရန် အခွင့်အရေး\nဇွန်ဘီ - အခမဲ့ ခရက်ဒစ် 25 ရရှိရန် အခွင့်အရေး\nဘုန်းတော်ကြီး - အခမဲ့ ခရက်ဒစ် 5 ရရှိရန် အခွင့်အရေး',
    ft_card_history_title: 'ဖဲဖွင့်ကစားမှု မှတ်တမ်း',
    ft_all: 'အားလုံး',
    ft_history_transaction: 'ငွေလွှဲမှတ်တမ်း',
    ft_time: 'အချိန်',
    ft_amount: 'ပမာဏ',
    ft_status: 'အခြေအနေ:',
    ft_status_processing: 'ဆောင်ရွက်နေဆဲ',
    ft_status_pending: 'ဆိုင်းငံ့ဆဲ',
    ft_status_cancelled_by_player: 'ပယ်ဖျက်ပြီး (ကစားသမားမှ)',
    ft_status_failed_by_system: 'မအောင်မြင် (စနစ်မှ)',
    ft_status_success: 'အောင်မြင်',

    ft_affiliate_title: 'သူငယ်ချင်းမိတ်ဆက်ရန်',
    ft_overview: 'ခြုံငုံသုံးသပ်ချက်',
    ft_members: 'အဖွဲ့ဝင်များ',
    ft_income_summary: 'ဝင်ငွေ အကျဉ်းချုပ်',
    ft_network: 'ကွန်ရက်',
    ft_income_from_network_all: 'ကွန်ရက်မှ စုစုပေါင်း ဝင်ငွေ',
    ft_from_last_month: 'ပြီးခဲ့သောလမှ',
    ft_invite_link: 'ဖိတ်ကြားလင့်ခ်',
    ft_copy: 'ကူးယူရန်',
    ft_copied: 'ကူးယူပြီးပါပြီ!',
    ft_withdrawable_income: 'ထုတ်ယူနိုင်သော ဝင်ငွေ',
    ft_withdraw_income: 'ဝင်ငွေ ထုတ်ယူရန်',
    ft_total_link_clicks: 'လင့်ခ် နှိပ်မှု စုစုပေါင်း',
    ft_total_members: 'အဖွဲ့ဝင် စုစုပေါင်း',
    ft_new_members_today: 'ယနေ့ အဖွဲ့ဝင်သစ်',
    ft_people_unit: 'ဦး',
    ft_history: 'မှတ်တမ်း',
    ft_how_to_build_network: 'ကွန်ရက် တည်ဆောက်နည်း',
    ft_total_active: 'အသက်ဝင် စုစုပေါင်း',
    ft_seven_days_ago: '7 ရက်အကြာက',
    ft_last_month: 'ပြီးခဲ့သောလ',
    ft_total_referred_members: 'မိတ်ဆက်အဖွဲ့ဝင် စုစုပေါင်း',
    ft_all_play_types: 'ကစားမှု အမျိုးအစားအားလုံး',
    ft_rank_no: 'အဆင့်',
    ft_network_details: 'ကွန်ရက် အသေးစိတ်',
    ft_date: 'ရက်စွဲ',
    ft_withdraw_amount: 'ထုတ်ယူပမာဏ',
    ft_search_income_source: 'ဝင်ငွေရင်းမြစ် ရှာရန်',
    ft_all_levels: 'အဆင့်အားလုံး',
    ft_all_types: 'အမျိုးအစားအားလုံး',
    ft_type_slot: 'စလော့-slot',
    ft_type_casino: 'ကာစီနို-casino',
    ft_type_winloss: 'အရှုံး-winloss',
    ft_today_to_today: 'ယနေ့ — ယနေ့',
    ft_clear: 'ရှင်းရန်',
    ft_search: 'ရှာရန်',
    ft_viewing_period: 'သင်ကြည့်ရှုနေသော ကာလ',
    ft_level_no: 'အဆင့်',
    ft_income_detail: 'ဝင်ငွေ အသေးစိတ်',
    ft_type: 'အမျိုးအစား',
    ft_bet_amount: 'လောင်းကြေး',
    ft_income: 'ဝင်ငွေ',
    ft_easy_rich_with_us: 'ကျွန်ုပ်တို့နှင့်အတူ လွယ်ကူစွာ ချမ်းသာပါ',
    ft_share_link_earn: 'လင့်ခ် မျှဝေရုံဖြင့် ဝင်ငွေရှာပါ',
  },
  lo: {
    ft_session_expired: 'ເຊດຊັນຂອງທ່ານໝົດອາຍຸແລ້ວ ກະລຸນາເຂົ້າສູ່ລະບົບອີກຄັ້ງ.',
    ft_claim_success: 'ເຮັດລາຍການຮັບເງິນສຳເລັດແລ້ວ',
    ft_claim_no_balance: 'ບໍ່ສາມາດເຮັດລາຍການໄດ້ ບໍ່ມີຍອດເງິນ',
    ft_claim_failed: 'ບໍ່ສາມາດເຮັດລາຍການໄດ້',
    ft_not_login: 'ທ່ານຍັງບໍ່ໄດ້ເຂົ້າສູ່ລະບົບ',
    ft_please_login: 'ກະລຸນາເຂົ້າສູ່ລະບົບ',
    ft_game_problem: 'ຕອນນີ້ເກມມີບັນຫາ ກະລຸນາລໍຖ້າຄາວໜຶ່ງ',
    ft_cancel_pro_confirm: 'ທ່ານຕ້ອງການຍົກເລີກການໃຊ້ໂປຣບໍ່?',
    ft_done: 'ດຳເນີນການສຳເລັດແລ້ວ',
    ft_cannot_proceed_wait: 'ບໍ່ສາມາດດຳເນີນການໄດ້ ກະລຸນາລໍຖ້າຄາວໜຶ່ງ',
    ft_pro_not_eligible: 'ທ່ານບໍ່ເຂົ້າເງື່ອນໄຂໂປຣໂມຊັນນີ້',
    ft_pro_pending: 'ທ່ານໃຊ້ໂປຣໂມຊັນຄ້າງໄວ້ ສາມາດເຕີມເງິນໄດ້ເລີຍ',

    ft_cashback_title: 'ຄືນຍອດເສຍ',
    ft_cashback_total_all: 'ຄືນຍອດເສຍສະສົມທັງໝົດ',
    ft_cashback_total_month: 'ຄືນຍອດເສຍສະສົມເດືອນນີ້',
    ft_cashback_percent: 'ຄືນຍອດເສຍ',
    ft_start_amount: 'ຍອດເລີ່ມຕົ້ນ 0 ບາດ',
    ft_your_loss: 'ຍອດເສຍຂອງທ່ານ',
    ft_withdraw: 'ຖອນເງິນ',
    ft_transaction_history: 'ປະຫວັດການເຮັດລາຍການ',
    ft_no_transaction: 'ບໍ່ພົບລາຍການ...',

    ft_category: 'ໝວດໝູ່',
    ft_two_types: '2 ປະເພດ',
    ft_popular_games: 'ເກມຍອດນິຍົມ',
    ft_game_camps: 'ຄ່າຍເກມ',
    ft_camps: 'ຄ່າຍ',
    ft_live_casino: 'ຄາສິໂນສົດ',
    ft_sport: 'ກິລາ',
    ft_fishing: 'ຍິງປາ',
    ft_arcade: 'ອາເຄດ',
    ft_games_unit: 'ເກມ',
    ft_day_label: 'ມື້ທີ',

    ft_daily_checkin: 'ເຊັກອິນປະຈຳວັນ',
    ft_turnover_condition: 'ເທີນໂອເວີ 500.- ຂຶ້ນໄປ',
    ft_checkin_sub: 'ຮັບທຸກວັນພຽງເຂົ້າມາເຊັກອິນ ພ້ອມທັງສະສົມເພື່ອຮັບລາງວັນທີ່ສູງຂຶ້ນ',
    ft_today: 'ມື້ນີ້',
    ft_checkin_collect: 'ເຊັກອິນສະສົມ',
    ft_checkin_collect_sub: 'ອີກ 3 ວັນ ໄດ້ຮັບສູງສຸດ ฿5',
    ft_day_unit: 'ວັນ',
    ft_max: 'ສູງສຸດ',
    ft_three_days: '3 ວັນ',
    ft_seven_days: '7 ວັນ',
    ft_fifteen_days: '15 ວັນ',
    ft_twentyfive_days: '25 ວັນ',

    ft_wheel_title: 'ກົງລໍ້ພາລວຍ',
    ft_spin_wheel: 'ໝູນກົງລໍ້',
    ft_deposit_get_ticket_1: 'ຝາກເງິນສະສົມ',
    ft_deposit_get_ticket_2: 'ບາດ ໄດ້ 1 ປີ້',
    ft_terms_of_service: 'ເງື່ອນໄຂການໃຫ້ບໍລິການ',
    ft_wheel_term_1: '• ຝາກເງິນສະສົມຄົບ 1,000 ບາດ ຈະໄດ້ຮັບ 1 ປີ້ (ສູງສຸດ 5 ປີ້ / ວັນ)',
    ft_wheel_term_2_a: '• ຍອດຝາກສະສົມຈະ ',
    ft_wheel_term_2_reset: 'ຣີເຊັດເປັນ 0',
    ft_wheel_term_2_b: ' ໃນເວລາ 00.00 ນ. ຂອງທຸກວັນ',
    ft_wheel_term_3: '*ປີ້ກົງລໍ້ຈະຖືກຄຳນວນແລະໄດ້ຮັບ ຕໍ່ເມື່ອເຂົ້າມາທີ່ໜ້ານີ້ເທົ່ານັ້ນ ຫາກບໍ່ເຂົ້າຈະບໍ່ໄດ້ຮັບ',
    ft_congratulations: 'ຂໍສະແດງຄວາມຍິນດີ',
    ft_receive_reward_at: 'ຮັບຂອງລາງວັນໄດ້ທີ່',
    ft_receive_reward: 'ຮັບລາງວັນ',
    ft_close: 'ປິດ',

    ft_card_done_today: 'ທ່ານເປີດໄພ່ຄົບແລ້ວໃນມື້ນີ້ ກະລຸນາລໍຖ້າມື້ໃໝ່',
    ft_not_enough_points: 'ແຕ້ມບໍ່ພໍໃນການຫຼິ້ນເກມນີ້',
    ft_login_before_play: 'ກະລຸນາເຂົ້າສູ່ລະບົບກ່ອນຫຼິ້ນ',
    ft_select_event_before_play: 'ກະລຸນາເລືອກກິດຈະກຳກ່ອນຫຼິ້ນ',
    ft_reset_cards_title: 'ທາງເຮົາຈະ reset ໄພ່ໃຫ້ໃໝ່',
    ft_reset_cards_text: 'ກະລຸນາກົດປຸ່ມ "ຕົກລົງ" ເພື່ອເຮັດການສຸ່ມໃໝ່',
    ft_cancel: 'ຍົກເລີກ',
    ft_card_event: 'ກິດຈະກຳເປີດໄພ່',
    ft_points_available: 'ຈຳນວນແຕ້ມທີ່ໃຊ້ໄດ້',
    ft_points_unit: 'ແຕ້ມ',
    ft_enter_play: 'ເຂົ້າຫຼິ້ນ',
    ft_event: 'ກິດຈະກຳ',
    ft_open_card: 'ເປີດໄພ່',
    ft_card_shuffled: 'ສຸ່ມໄພ່ສຳເລັດແລ້ວ',
    ft_join_conditions: 'ເງື່ອນໄຂໃນການຮ່ວມສະໜຸກ',
    ft_open_condition_none: 'ເງື່ອນໄຂໃນການເປີດ: ບໍ່ພົບ',
    ft_open_twice_a_day: 'ສາມາດເປີດໄດ້ວັນລະ 2 ຄັ້ງ ເທົ່ານັ້ນ',
    ft_details: 'ລາຍລະອຽດ :',
    ft_card_reward_list: 'ຝາກ 100 - 999 ບາດ\nຮັບສິດເປີດຟຣີ ວັນລະ 2 ຄັ້ງ\n\nແວມໄພ - ລຸ້ນຮັບ ເຄຣດິດຟຣີ 50\nເຈສັນ ວໍຮີສ໌ - ລຸ້ນຮັບ ເຄຣດິດຟຣີ 10\nເຟຣດດີ້ ຄຣູເກີ - ລຸ້ນຮັບ ເຄຣດິດຟຣີ 15\nຜີດິບ - ລຸ້ນຮັບ ເຄຣດິດຟຣີ 25\nນັກບວດ - ລຸ້ນຮັບ ເຄຣດິດຟຣີ 5',
    ft_card_history_title: 'ປະຫວັດການຫຼິ້ນເປີດໄພ່',
    ft_all: 'ທັງໝົດ',
    ft_history_transaction: 'ປະຫວັດທຳລາຍການ',
    ft_time: 'ເວລາ',
    ft_amount: 'ຈຳນວນເງິນ',
    ft_status: 'ສະຖານະ :',
    ft_status_processing: 'ກຳລັງດຳເນີນການ',
    ft_status_pending: 'ລໍດຳເນີນການ',
    ft_status_cancelled_by_player: 'ຍົກເລີກ (ຍົກເລີກໂດຍຜູ້ຫຼິ້ນ)',
    ft_status_failed_by_system: 'ບໍ່ສຳເລັດ (ໂດຍລະບົບ)',
    ft_status_success: 'ສຳເລັດ',

    ft_affiliate_title: 'ແນະນຳໝູ່',
    ft_overview: 'ພາບລວມ',
    ft_members: 'ສະມາຊິກ',
    ft_income_summary: 'ສະຫຼຸບລາຍໄດ້',
    ft_network: 'ເຄືອຂ່າຍ',
    ft_income_from_network_all: 'ລາຍໄດ້ຈາກເຄືອຂ່າຍ ທັງໝົດ',
    ft_from_last_month: 'ຈາກເດືອນທີ່ແລ້ວ',
    ft_invite_link: 'ລິ້ງເຊີນຊວນ',
    ft_copy: 'ຄັດລອກ',
    ft_copied: 'ຄັດລອກແລ້ວ!',
    ft_withdrawable_income: 'ລາຍໄດ້ທີ່ຖອນໄດ້',
    ft_withdraw_income: 'ຖອນລາຍໄດ້',
    ft_total_link_clicks: 'ຈຳນວນຄລິກລິ້ງທັງໝົດ',
    ft_total_members: 'ຈຳນວນສະມາຊິກທັງໝົດ',
    ft_new_members_today: 'ສະມາຊິກໃໝ່ມື້ນີ້',
    ft_people_unit: 'ຄົນ',
    ft_history: 'ປະຫວັດ',
    ft_how_to_build_network: 'ວິທີການສ້າງເຄືອຂ່າຍ',
    ft_total_active: 'ຍອດແອັກທີບທັງໝົດ',
    ft_seven_days_ago: '7 ວັນທີ່ແລ້ວ',
    ft_last_month: 'ເດືອນທີ່ແລ້ວ',
    ft_total_referred_members: 'ແນະນຳສະມາຊິກທັງໝົດ',
    ft_all_play_types: 'ຍອດການຫຼິ້ນທຸກປະເພດ',
    ft_rank_no: 'ລຳດັບທີ',
    ft_network_details: 'ລາຍລະອຽດເຄືອຂ່າຍ',
    ft_date: 'ວັນທີ',
    ft_withdraw_amount: 'ຍອດຖອນ',
    ft_search_income_source: 'ຄົ້ນຫາທີ່ມາລາຍໄດ້',
    ft_all_levels: 'ທຸກເລເວວ',
    ft_all_types: 'ທຸກປະເພດ',
    ft_type_slot: 'ສະລັອດ-slot',
    ft_type_casino: 'ຄາສິໂນ-casino',
    ft_type_winloss: 'ຍອດເສຍ-winloss',
    ft_today_to_today: 'ມື້ນີ້ — ມື້ນີ້',
    ft_clear: 'ລ້າງຄ່າ',
    ft_search: 'ຄົ້ນຫາ',
    ft_viewing_period: 'ທ່ານກຳລັງເບິ່ງຊ່ວງເວລາ',
    ft_level_no: 'ລະດັບທີ',
    ft_income_detail: 'ລາຍລະອຽດການທຳລາຍໄດ້',
    ft_type: 'ປະເພດ',
    ft_bet_amount: 'ຍອດແທງ',
    ft_income: 'ລາຍໄດ້',
    ft_easy_rich_with_us: 'ລວຍງ່າຍໆ ກັບ ພວກເຮົາ',
    ft_share_link_earn: 'ພຽງແບ່ງປັນລິ້ງກໍ່ສ້າງລາຍໄດ້',
  },
};

Object.keys(ext).forEach((l) => {
  translations[l] = Object.assign({}, translations[l], ext[l]);
});

export default ext;
